<template>
  <div v-loading="loading" class="admin">
    <h2>Editar Categoria</h2>
    <el-form ref="form" :model="book" label-width="120px">
      <el-row :gutter="20">
        <el-col :lg="8" :offset="8">
          <el-form-item label="Categoria">
            <el-input v-model="tag.value"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :lg="8" :offset="8">
          <el-form-item style="float: right">
            <el-button type="primary" @click="updateTag">Editar</el-button>
            <el-button type="danger" @click="deleteTag">Deletar</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { updateTag, getTag, deleteTag } from "../../../services/tags";
export default {
  data() {
    return {
      tag: {},
    };
  },

  methods: {
    async getTag(id) {
      const response = await getTag(id);
      this.tag = response.data;
    },
    async updateTag() {
      const response = await updateTag(this.$route.params.id, this.tag);
      if (response.status === 204) {
        this.$message.success("Tag atualizada com sucesso!");
        this.$router.push(`/admin/tags`);
      }
    },
    async deleteTag() {
      const shouldDelete = await this.$confirm(
        "Essa é uma operação definitiva. Tem certeza que deseja continuar?",
        "Atenção",
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      );
      if (shouldDelete) {
        const response = await deleteTag(this.tag._id.$oid);
        if (response.status === 204) {
          this.$message.success("Tag deletada com sucesso!");
          this.$router.push(`/admin/tags`);
        }
      }
    },
  },
  created() {
    this.getTag(this.$route.params.id);
  },
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.inputSelection {
  text-align: center;
}
.admin {
  margin: 30px;
}
</style>
